module.exports = __webpack_public_path__ + "img/it.e67a7830.svg";